import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './en.json';
import uaTranslation from './ua.json';
import indexedDBService from '../services/IndexedDBService';

const resources = {en: {translation: enTranslation}, ua: {translation: uaTranslation}, ru: {translation: uaTranslation}};

const fallbackLanguage = 'ua';

// Initialize i18n with async language detection
const initializeI18n = async () => {
  try {
    const browserLanguage = await indexedDBService.getSetting('language');
    const language = !!resources[browserLanguage] ? browserLanguage : fallbackLanguage;

    i18n.use(initReactI18next).init({
      resources, 
      lng: language
    });
  } catch (error) {
    console.error('Failed to load language setting from IndexedDB:', error);
    // Use fallback language if IndexedDB fails
    i18n.use(initReactI18next).init({
      resources, 
      lng: fallbackLanguage
    });
  }
};

initializeI18n();

export default i18n;
